import React from "react";
import styles from "./EventMainData.module.scss";
import EventSchedule from "../ui/EventMainData/EventSchedule";
import EventJoinedUsers from "../ui/EventMainData/EventJoinedUsers";
import EventPartners from "../ui/EventMainData/EventPartners";
import EventOrganizer from "../ui/EventMainInfo/EventOrganizer";

const EventMainData = () => {
  return (
    <div className={styles.EventMainData}>
      <div className={styles.EventMainData_Content}>
        <div className={styles.EventMainData_Content_Left}>
          <EventSchedule />
        </div>
        <div className={styles.EventMainData_Content_Right}>
          <EventJoinedUsers />
        </div>
      </div>
      <div className={styles.EventMainData_MobileBlock}>
        <EventOrganizer />
      </div>
      <EventPartners />
    </div>
  );
};

export default EventMainData;
